import React, {useState} from "react";
import {Box, Typography, Stack, Grid, Paper} from "@mui/material";
// import {styled} from "@mui/material/styles";
import Modal from '@mui/material/Modal'

import orion_svg_icon from "../media/img/ORION.svg";
import icarus_svg_icon from "../media/img/ICARUS.svg";
import hermes_svg_icon from "../media/img/HERMES.svg";
import atlas_svg_icon from "../media/img/ATLAS.svg";

import CircleIcon from "../components/CircleIcon";

// const Item = styled(Paper)(({ theme }) => ({
//     backgroundColor: '#fff',
//     ...theme.typography.body2,
//     padding: theme.spacing(1),
//     textAlign: 'center',
//     color: (theme.vars ?? theme).palette.text.secondary,
//     ...theme.applyStyles('dark', {
//         backgroundColor: '#1A2027',
//     }),
// }));

const EventPaper = (props) => {
    const [hovered, setHovered] = useState(false);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,

        bgcolor: 'background.paper',
        backgroundColor: '#A8ACB0',
        // border: '2px solid #000',
        boxShadow: 24,
        pt: 2,
        px: 4,
        pb: 3,
    };
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => {
        // setOpen(true);
        window.location.href = `/projects/${props.projectID}`;

    };
    const handleClose = () => {
        setOpen(false);
    };

    let getInsideBox = (childssss) => {
        return (
            // <Grid container direction="row" spacing={2}
            //       sx={{
            //           justifyContent: "space-evenly",
            //           alignItems: "stretch",
            //
            //       }}
            // >
            //
            //     {React.Children.map(childssss, (child, i) => (
            //         <Grid item key={i} sx={{alignContent: "center",  justifyContent: "space-between"}}
            //               size={{ xs: 6, md: 6, lg: 6 }}
            //         >
            //             {child}
            //         </Grid>
            //     ))}
            //
            // </Grid>
            childssss
        );
    };

    return (
        <React.Fragment>

            <Paper
                elevation={hovered ? 12 : 1} // change elevation on hover
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}

                onClick={handleOpen}

                sx={{
                    p: 2,
                    textAlign: "center",
                    transition: "all 0.3s ease", // smooth shadow transition
                    cursor: "pointer",
                    backgroundColor: '#A8ACB0',
                    width: '100%',
                }}

            >
                {/*<Grid container direction="row" spacing={2}>*/}

                {/*    {React.Children.map(props.children, (child, i) => (*/}
                {/*        <Grid item key={i}>*/}
                {/*            {child}*/}
                {/*        </Grid>*/}
                {/*    ))}*/}

                {/*</Grid>*/}
                {getInsideBox(props.children)}

            </Paper>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
            >
                <Box sx={{ ...style, }}>
                    {/*<Grid container direction="row" spacing={2}>*/}

                    {/*    {React.Children.map(props.children, (child, i) => (*/}
                    {/*        <Grid item key={i}>*/}
                    {/*            {child}*/}
                    {/*        </Grid>*/}
                    {/*    ))}*/}

                    {/*</Grid>*/}

                    {getInsideBox(props.children)}

                </Box>
            </Modal>

        </React.Fragment>
    );
};


export const Projects = () => {

    return (
        <Paper
            elevation={12}
            sx={{
                padding: 3,
                borderRadius: 3,
                marginTop: 3,
                backgroundColor: (theme) => theme.palette.missionGold.cream,
            }}
        >
        <Stack

            direction="column"
            spacing={2}
            sx={{
                scrollSnapAlign: "start",
                // backgroundColor: (theme) => theme.palette.missionGold.main,
                // background: 'hsl(221.4, 30.5%, 18.6%)',
                // color: "#fff",
                width: "100%",
                flexDirection: "column",
                alignItems: "stretch",
                justifyContent: "center",
                textAlign: "center",

            }}
        >

            <Typography
                variant="h4"
                component="h3" sx={{mb: 2}}>
                {/*<Typography variant="h4" component="h5" style={{backgroundColor: null}}>*/}
                <b>Ongoing Projects</b>
            </Typography>

            <Grid item size={12} container spacing={2} sx={{
                justifyContent: "space-evenly",
                alignItems: "stretch",
            }}
            >

                <Grid size={{ xs: 6, md: 4, lg:3 }} sx={{ display: "flex" }}>
                    {/*<EventPaper>Nasa</EventPaper>*/}

                    <EventPaper projectID={"icarus"}>
                        <CircleIcon size={56} >
                            <img src={icarus_svg_icon} alt="" />

                        </CircleIcon>
                    </EventPaper>

                </Grid>
                <Grid size={{ xs: 6, md: 4, lg:3}} sx={{ display: "flex" }}>
                    <EventPaper  projectID={"hermes"}>
                        <CircleIcon size={56} color="#333">
                            <img src={hermes_svg_icon} alt="" />
                        </CircleIcon>

                    </EventPaper>
                </Grid>
                <Grid size={{ xs: 6, md: 4, lg:3 }} sx={{ display: "flex" }}>
                    <EventPaper projectID={"orion"} >

                        <CircleIcon size={56} color="#333">
                            <img src={orion_svg_icon} alt="" />
                        </CircleIcon>
                    </EventPaper>
                </Grid>

                <Grid size={{ xs: 6, md: 4, lg:3 }} sx={{ display: "flex" }}>
                    <EventPaper projectID={"atlas"} >

                        <CircleIcon size={56} color="#333">
                            <img src={atlas_svg_icon} alt="" />
                        </CircleIcon>
                    </EventPaper>
                </Grid>

            </Grid>

        </Stack>

        </Paper>


    );
}